import React from 'react';
import i18n from 'i18n-react';

import { Toolbox, ContentHeader } from 'C4';

const FastFactsView = () => (
  <div className="contentContainer">
    <ContentHeader
      header={i18n.translate('nav.promote')}
      subtitle={i18n.translate('pageDescriptions.promote')}
      social
    />
    <Toolbox overrideKey="fastFacts" />
  </div>
);

export default FastFactsView;
